/* ============================================================================
   Ancona Pass 25 — signature layer JS (ancona-signature.js)  [P2 + P7]
   Two once-only, reduced-motion-gated signature moments (visuals live in
   assets/ancona-signature.css; this file only toggles classes):
   1. light (P2 — Ancona Light, hero pass): once per browser session
      (sessionStorage 'ancona:v1:lightpass'), 400ms after load, one slow 115°
      light pass across the homepage hero plate — class .ancona-lightpass on
      .ancona-hero2__main (the CSS animates its ::before; the hero's ::after
      is already the gold frame and is untouched). The flag is set only when
      the pass actually runs, so a session that starts off the homepage still
      gets its one pass on first hero sighting.
   2. pulse (P7 — gold ring on Save): on ancona:saved_add, one 1px gold ring
      breathes out from the header Saved count — class .ancona-ring on
      .ancona-hub__saved:not([hidden]) ONLY (never the generic .ancona-hub__btn,
      which would ring the compare chip too). This script is loaded AFTER
      ancona-launch.js, so the frozen hub listener registers first and unhides
      the chip before we query; the query still runs inside
      requestAnimationFrame to cover the first-ever save. Cross-tab mirror
      events (detail.source === 'tabsync' from ancona-metrics.js) never ring —
      the ring acknowledges THIS shopper's action.
   Both features are purely decorative: under prefers-reduced-motion nothing
   is toggled and no information is lost (counts and labels update via the
   frozen layers regardless).
   Feature flags: this <script> tag's data-ancona-signature attribute (tokens:
   light | pulse). Absent attribute -> all; empty string -> none.
   Revert: remove the data-ancona-signature line(s) in layout/theme.liquid +
   this file (the signature CSS layer is a separate revert unit).
   ============================================================================ */
(function () {
  'use strict';
  try {
    if (window.__anconaSignature) return;
    window.__anconaSignature = true;

    var script = document.currentScript;
    var featAttr = script ? script.getAttribute('data-ancona-signature') : null;
    /* Absent attribute → all features; explicit empty string → none (documented revert path). */
    var FEATURES = (featAttr == null ? 'light,pulse' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function on(f) { return FEATURES.indexOf(f) !== -1; }

    function motionOK() {
      try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: no-preference)').matches; }
      catch (e) { return false; }
    }

    var SS = null;
    try { SS = window.sessionStorage; SS.setItem('ancona:v1:t', '1'); SS.removeItem('ancona:v1:t'); } catch (e) { SS = null; }

    /* ---- 1) light (P2): once-per-session hero light pass -------------------- */
    var LIGHT_KEY = 'ancona:v1:lightpass';
    function initLight() {
      if (!motionOK()) return; /* purely decorative — nothing for reduced-motion users to miss */
      if (!SS) return;         /* without sessionStorage "once per session" cannot be honored — skip */
      try { if (SS.getItem(LIGHT_KEY)) return; } catch (e) { return; }
      var run = function () {
        window.setTimeout(function () {
          try {
            var plate = document.querySelector('.ancona-hero2__main');
            if (!plate) return; /* not the homepage hero — keep the session's pass unspent */
            try { SS.setItem(LIGHT_KEY, '1'); } catch (e) {}
            plate.classList.add('ancona-lightpass');
            /* Clean up after the single pass; the fallback timer covers the
               case where the CSS layer is absent and no animation ever ends. */
            var done = function () { plate.classList.remove('ancona-lightpass'); };
            plate.addEventListener('animationend', done, { once: true });
            window.setTimeout(done, 3000);
          } catch (e) {}
        }, 400);
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }

    /* ---- 2) pulse (P7): gold ring acknowledgment on Save -------------------- */
    function initPulse() {
      document.addEventListener('ancona:saved_add', function (e) {
        try {
          if (!motionOK()) return;
          if (e && e.detail && e.detail.source === 'tabsync') return; /* mirror event, not this shopper's action */
          window.requestAnimationFrame(function () {
            /* Re-query AFTER the frozen launch.js listener has unhidden the
               chip (first-ever save creates/reveals it in the same tick). */
            var chip = document.querySelector('.ancona-hub__saved:not([hidden])');
            if (!chip) return;
            chip.classList.remove('ancona-ring');
            void chip.offsetWidth; /* restart the animation on rapid re-saves */
            chip.classList.add('ancona-ring');
            var done = function () { chip.classList.remove('ancona-ring'); };
            chip.addEventListener('animationend', done, { once: true });
            window.setTimeout(done, 900); /* fallback if the CSS layer is absent */
          });
        } catch (err) { /* the ring must never break saving */ }
      });
    }

    function boot() {
      /* Each feature is isolated: a throw in one can never abort the other. */
      if (on('light')) { try { initLight(); } catch (e) {} }
      if (on('pulse')) { try { initPulse(); } catch (e) {} }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* the signature layer must never break the page */ }
})();
